var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrenchSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 172.445C384 243.461 345.303 305.23 288 338.453V463.992C288 490.508 266.51 512 240 512H144C117.49 512 96 490.508 96 463.992V338.453C38.697 305.23 0 243.461 0 172.445C0 98.035 42.4 33.672 104.305 1.828C115.07 -3.711 128 3.992 128 16.102V159.969L192 223.973L256 159.969V16.102C256 3.992 268.93 -3.711 279.695 1.828C341.6 33.672 384 98.035 384 172.445Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrenchSimple);
export default __webpack_public_path__ + "static/media/wrench-simple.fb1e6f51d9836901d8b039b513af836b.svg";
export { ForwardRef as ReactComponent };